import { useState } from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { FormHelperText, Grid, MenuItem, Paper, Select } from '@mui/material';
import { FormikProps } from 'formik';
import { CompactPicker } from 'react-color';
import { ResourceType } from '../../../types/ResourceType';

const PREFIX = 'labelForm';
const classes = {
  root: `${PREFIX}-root`,
  pointerCursor: `${PREFIX}-pointerCursor`,
  dropdown: `${PREFIX}-dropdown`,
  name: `${PREFIX}-name`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`& .${classes.root}`]: {
    '& .MuiTextField-root': {
      margin: theme.spacing(2),
    },
  },

  [`& .${classes.pointerCursor}`]: {
    cursor: 'pointer',
  },

  [`& .${classes.dropdown}`]: {
    width: 200,
    display: 'flex',
    justifyContent: 'left',
  },

  [`& .${classes.name}`]: {
    width: 200,
  },
}));

export interface LabelInput {
  id: string;
  name: string;
  colorRgb: string;
  resourceType?: number;
}
interface EditLabelProps {
  formRef: FormikProps<LabelInput>;
}

export default function EditLabel(props: EditLabelProps) {
  const [colorRgb, setColorRgb] = useState(props.formRef?.values?.colorRgb);

  return (
    <StyledPaper elevation={3} style={{ overflowX: 'auto' }}>
      <form onSubmit={props.formRef.handleSubmit} style={{ height: 350 }}>
        <Grid container spacing={3}>
          <Grid xs={12} sm={12} lg={12} item>
            <Grid xs={12} item className={classes.root}>
              <TextField
                id='name'
                name='name'
                label='Name'
                value={props.formRef.values?.name ?? ''}
                onChange={props.formRef.handleChange}
                error={props.formRef.touched.name && Boolean(props.formRef.errors.name)}
                helperText={props.formRef.touched.name && props.formRef.errors.name}
                placeholder='Enter Name'
                variant='standard'
                size='small'
                fullWidth
                required
                margin='dense'
                style={{ width: 300 }}
              />
            </Grid>

            <Grid xs={12} item style={{ marginLeft: 15 }}>
              <Select
                variant='outlined'
                id='resourceType'
                name='resourceType'
                value={props.formRef.values?.resourceType}
                onChange={(e) => props.formRef.setFieldValue('resourceType', e.target.value ?? 0)}
                onBlur={props.formRef.handleBlur}
                error={props.formRef.touched?.resourceType && Boolean(props.formRef.errors?.resourceType)}
                size='small'
                className={classes.dropdown}
                disabled={props.formRef.values?.id !== ''}
              >
                {Object.keys(ResourceType)
                  .filter((key) => {
                    const resourceTypeId = ResourceType[key];
                    // we need show show only 4 ResourceType (Device=1, Equipment=2, Reader=3, Facility=4)
                    return !isNaN(Number(resourceTypeId)) && resourceTypeId <= 4;
                  })
                  .map((resourceType, index: number) => {
                    return (
                      <MenuItem key={index} value={ResourceType[resourceType]}>
                        {resourceType}
                      </MenuItem>
                    );
                  })}
              </Select>
              <FormHelperText error={props.formRef.touched?.resourceType && Boolean(props.formRef.errors?.resourceType)}>
                {props.formRef.touched?.resourceType && props.formRef.errors?.resourceType}
              </FormHelperText>
            </Grid>

            <Grid xs={12} sm={12} item className={classes.root}>
              <TextField
                id='colorRgb'
                name='colorRgb'
                label='Color'
                value={props.formRef.values?.colorRgb ?? ''}
                onChange={props.formRef.handleChange}
                error={props.formRef.touched.colorRgb && Boolean(props.formRef.errors.colorRgb)}
                helperText={props.formRef.touched.colorRgb && props.formRef.errors.colorRgb}
                placeholder='Enter Color'
                variant='standard'
                size='small'
                style={{ width: 130 }}
                required
                margin='dense'
              />
              <br />
              <div style={{ marginLeft: 15 }}>
                <CompactPicker
                  color={colorRgb}
                  onChange={(e: { hex: string }) => {
                    setColorRgb(e.hex);
                    props.formRef.setFieldValue('colorRgb', e.hex ?? 0);
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </StyledPaper>
  );
}
